import { render, staticRenderFns } from "./CustomerMerge.vue?vue&type=template&id=5b789948&"
import script from "./CustomerMerge.vue?vue&type=script&lang=js&"
export * from "./CustomerMerge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports